// extracted by mini-css-extract-plugin
module.exports = {"container":"OrganizationContentLayout_container__3xFnh"};